import React from 'react'

interface VerticalDividerProps {
  height?: string
  width?: string
  color?: string
  className?: string
}

const VerticalDivider: React.FC<VerticalDividerProps> = ({
  height = '48px',
  width = '2px',
  color = '#D1D5DB',
  className = '',
}) => {
  return (
    <div
      className={`vertical-divider ${className}`}
      style={{
        width: width,
        height: height,
        backgroundColor: color,
        border: 'none',
        margin: 0,
        display: 'inline-block',
      }}
    />
  )
}

export default VerticalDivider 